import { SagaIterator } from 'redux-saga';
import { fork } from 'redux-saga/effects';
import plantDiseasesListSaga from 'modules/PlantDiseases/saga/list';

export default function* plantDiseasesSaga(): SagaIterator {
  yield fork(plantDiseasesListSaga);
}
